import React, { useState } from 'react';
import { Header } from '../components/layout/Header';
import { useAuth } from '../hooks/useAuth';
import { useProjects } from '../hooks/useProjects';
import { ProjectList } from '../components/projects/ProjectList';
import { CreateProjectModal } from '../components/projects/CreateProjectModal';
import { CollaborationInvites } from '../components/collaboration';
import { usePageTitle } from '../hooks/usePageTitle';

export const Dashboard: React.FC = () => {
  usePageTitle('Dashboard');
  const { user } = useAuth();
  const { ownedProjects, sharedProjects, loading, error } = useProjects();
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  const handleCreateSuccess = () => {
    // Modal will close automatically and projects will update via real-time listener
  };

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#EFE4D2' }}>
      <Header userEmail={user?.email || undefined} />

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Welcome Section */}
        <div className="mb-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-2">
            Welcome back{user?.displayName ? `, ${user.displayName}` : ''}!
          </h2>
          <p className="text-gray-600">
            Manage your InsightStudio Labs projects and personas
          </p>
        </div>

        {/* Collaboration Invites */}
        <CollaborationInvites />

        {/* My Projects Section */}
        <div className="bg-white rounded-lg shadow mb-6">
          <div className="px-6 py-4 border-b border-gray-200">
            <div className="flex items-center justify-between">
              <h3 className="text-xl font-semibold text-gray-900">
                My Projects ({ownedProjects.length})
              </h3>
              <button
                className="inline-flex items-center px-4 py-2 bg-primary-500 text-white rounded-md font-medium hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 transition-colors"
                onClick={() => setIsCreateModalOpen(true)}
              >
                <svg
                  className="w-5 h-5 mr-2"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 4v16m8-8H4"
                  />
                </svg>
                Create Project
              </button>
            </div>
          </div>

          {/* Project List */}
          <div className="px-6 py-6">
            <ProjectList projects={ownedProjects} loading={loading} error={error} />
          </div>
        </div>

        {/* Shared with Me Section */}
        {(sharedProjects.length > 0 || loading) && (
          <div className="bg-white rounded-lg shadow">
            <div className="px-6 py-4 border-b border-gray-200">
              <h3 className="text-xl font-semibold text-gray-900">
                Shared with Me ({sharedProjects.length})
              </h3>
            </div>

            {/* Project List */}
            <div className="px-6 py-6">
              <ProjectList projects={sharedProjects} loading={loading} error={error} showOwnerInfo={true} />
            </div>
          </div>
        )}

        {/* Create Project Modal */}
        <CreateProjectModal
          isOpen={isCreateModalOpen}
          onClose={() => setIsCreateModalOpen(false)}
          onSuccess={handleCreateSuccess}
        />
      </main>
    </div>
  );
};
